import { useSelector } from "react-redux";

/**
 * Custom hook to access localizes data from Redux store
 * @returns {Object} Object containing localizes data, loading state, error state, and helper functions
 */
export const useLocalizes = () => {
  const { data, loading, error } = useSelector((state) => state.localizes);

  /**
   * Get a specific localization value by key
   * @param {string} key - The localization key to retrieve
   * @param {string} defaultValue - Default value if key is not found
   * @returns {string} The localized value or default value
   */
  const getLocalizedValue = (key, defaultValue = "") => {
    if (!data?.data?.[0]?.attributes?.localize) {
      return defaultValue;
    }
    
    const localizeData = data.data[0].attributes.localize;
    return localizeData[key] || defaultValue;
  };

  /**
   * Get all localization data
   * @returns {Object} All localization data or empty object
   */
  const getAllLocalizedData = () => {
    return data?.data?.[0]?.attributes?.localize || {};
  };

  return {
    data,
    loading,
    error,
    getLocalizedValue,
    getAllLocalizedData,
  };
}; 